import React, { useContext } from "react";
import { useBlocker } from "react-router-dom";
import { HeadingText, ParagraphText, UBAppModal } from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import styles from "./styles.module.css";
import { CloseIcon } from "../../../assets/icons/icon";
import { Box } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const RouteLeavingGuard = ({
  message,
  when,
  cancelText,
  confirmText,
  title,
  handleConfirm = () => {},
  id = "",
  isConfirmBtn = true,
}) => {
  const [I18n] = useContext(LanguageContext);

  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      when && currentLocation.pathname !== nextLocation.pathname,
  );

  const closeModal = () => {
    triggerLogEvent(analytics, "navigation_leave_cancelled");
    blocker.reset?.();
  };

  const handleConfirmNavigationClick = () => {
    triggerLogEvent(analytics, "navigation_leave_confirmed");
    blocker.proceed?.();
    handleConfirm();
  };
  return (
    <>
      <UBAppModal
        id="route_leaving_guard_modal"
        className={`confirmationModal ${styles.confirmationModal}`}
        open={blocker.state === "blocked"}
        header={{}}
        footer={
          isConfirmBtn
            ? [
                {
                  data: {
                    className: `ubSecondaryButton`,
                    title: cancelText || I18n.cancel,
                    onClick: () => closeModal(),
                    id: `${id}_cancel`,
                  },
                },
                {
                  data: {
                    className: `ubDeleteButton`,
                    title: confirmText || I18n.yes,
                    onClick: handleConfirmNavigationClick,
                    id: `${id}_yes`,
                  },
                },
              ]
            : [
                {
                  data: {
                    className: `ubSecondaryButton`,
                    title: cancelText || I18n.cancel,
                    onClick: () => closeModal(),
                    id: `${id}_cancel`,
                  },
                },
              ]
        }
      >
        <Box>
            <ParagraphText className="fontSize16 fontWeight500 newFontColor">
              {title || I18n.close_without_saving}         
            </ParagraphText>
            <ParagraphText className="fontSize14 fontWeight400 newLightColor mt-2">              
                {message ||
                  I18n.unsaved_changes_go_back_message ||
                  "You have unsaved changes. Are you sure you want to go back"}       
            </ParagraphText>
          </Box>
      </UBAppModal>
    </>
  );
};

export default RouteLeavingGuard;
